// src/types/Response.ts

import { z } from 'zod';

import { UserProfileSchema } from '@/types/UserProfile';

export enum ResponseStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    VIDEO_PROCESSED = 'video_processed',
    PUBLISHED = 'published',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    SCORED = 'scored',
    JUDGING = 'judging',
    COMPLETED = 'completed',
    FAILED = 'failed',
}
const ResponseStatusEnum = z.nativeEnum(ResponseStatus);

export const ResponseSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    content_type: z.literal('response'),
    objectFit: z.string().optional().default('contain'),
    user_id: z.string(),
    challenge_id: z.string(),
    challenge_user_id: z.string(),
    title: z.string(),
    status: z.string().optional(),
    video_status: z.string().optional(),
    video_url: z.string().nullable().optional(),
    thumbnail_url: z.string().nullable().optional(),
    thumbnail_alternates: z.array(z.string()).optional(),
    judges_rank: z.number(),
    like_count: z.number(),
    comment_count: z.number(),
    trending_score: z.number(),
    view_count: z.number(),
    risk_reward_multiplier: z.number(),
    ttl: z.number().nullable().optional(),
    created_at: z.string().optional(),
    updated_at: z.string().optional(),

    // Frontend-only extras
    profile: UserProfileSchema.optional().nullable(),
    judge: z.record(z.any()).optional().nullable(),
    user_username: z.string().optional().nullable(),
    user_profile_photo_url: z.string().optional().nullable(),
});

export type Response = z.infer<typeof ResponseSchema>;

export const now = () =>
    new Date()
        .toISOString()
        .replace('Z', '+0000')
        .replace(/\.\d+/, (m) => (m + '000').slice(0, 7));

export function createPlaceholderResponse(
    responseId: string,
    userId: string,
    challengeId: string,
    challengeUserId: string
): Response {
    return ResponseSchema.parse({
        PK: responseId,
        SK: 'BASE',
        user_id: userId,
        content_type: 'response',
        challenge_id: challengeId,
        challenge_user_id: challengeUserId,
        title: '',
        status: 'pending',
        video_status: 'pending',
        video_url: '',
        thumbnail_url: '',
        thumbnail_alternates: [],
        judges_rank: 0,
        like_count: 0,
        comment_count: 0,
        trending_score: 1,
        view_count: 0,
        risk_reward_multiplier: 1,
        created_at: now(),
        updated_at: now(),
    });
}
